import React, { useState } from 'react';

const FileTags = ({ value, data, tableManager }) => {
  const {
    config: {
      additionalProps: { cell: additionalProps = {} },
    },
  } = tableManager;

  const classNames = ('rgt-cell-inner rgt-text-truncate ' + (additionalProps.className || '')).trim();

  // Handle cases when value is undefined or null
  const tags = (value ? value.split(',') : []).map(tag => tag.trim());
  
  const [showAll, setShowAll] = useState(false);

  const handleShowAll = () => {
    setShowAll(true);
  };

  return (
    <div className="tags-container">
      {tags.slice(0, showAll ? tags.length : 3).map((tag, index) => (
        <span key={index} className="tag-single" title={tag}>
          {tag}
        </span>
      ))}
      {!showAll && tags.length > 3 && (
        <span className="tag-single btn-more" onClick={handleShowAll}>
          +{tags.length - 3} more
        </span>
      )}
    </div>
  );
};

export default FileTags;
